export enum NetboxStatusEvent {
  Init = 'netbox.status.init',
  Get = 'netbox.status.get',
  Send = 'netbox.status.send',
}
